export const carMenuRouter = [{
  // has: 'vehicle-list',
  path: 'vehicle/list',
  icon: ' iconfont iconrecord',
  name: 'carRecordList',
  title: '车辆档案',
  component: () => import('@/views/gip/record/list.vue')
}]



// WEBPACK FOOTER //
// ./src/router/record/car.js